module.exports = __webpack_public_path__ + "static/media/member4.46808f0e.jpg";